<template>
  <div class="meter-reading-size-online">
    <Echart ref="option" :options="option" style="height: 100%" />
  </div>
</template>

<script>
import { postAction } from '@/api/manage'

export default {
  name: 'MeterReadingSizeMeterNumAndOnline',
  data() {
    return {
      option: {},
      url: {
        queryLargeScreenCalibreRate: "/jeecg-charge/meter/meterReadingLargeScreen/queryLargeScreenCalibreRate"
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.getData()
    },
    
    getData() {
      postAction(this.url.queryLargeScreenCalibreRate, {}).then(res => {
        if (res.success) {
          this.setOption(res.result)
        } else {
          this.setOption(this.getMockData())
        }
      }).catch(() => {
        this.setOption(this.getMockData())
      })
    },
    
    getMockData() {
      return {
        xdata: ['DN15', 'DN20', 'DN25', 'DN32', 'DN40', 'DN50'],
        ydata: [
          { num: 5432, rate: 0.96 },
          { num: 3891, rate: 0.965 },
          { num: 2987, rate: 0.968 },
          { num: 1568, rate: 0.949 },
          { num: 892, rate: 0.96 },
          { num: 497, rate: 0.964 }
        ]
      }
    },
    
    setOption(list) {
      const seriesData = []
      const num = []
      const rate = []
      
      if (list.ydata) {
        list.ydata.map(item => {
          num.push(item.num)
          rate.push(item.rate * 100)
        })
      }
      
      seriesData[0] = {
        name: this.$t('数量'),
        type: 'bar',
        barMaxWidth: 30,
        stack: 'sum',
        smooth: true,
        symbol: "circle",
        animationDelay: (0 * 200) - 100,
        animationDuration: 300,
        data: num.length > 0 ? num : [5432, 3891, 2987, 1568, 892, 497]
      }
      
      seriesData[1] = {
        name: this.$t('在线率(%)'),
        type: 'line',
        yAxisIndex: 1,
        symbol: 'circle',
        animationDelay: 1000,
        stack: 'Total',
        smooth: true,
        animationDuration: 300,
        data: rate.length > 0 ? rate : [96, 96.5, 96.8, 94.9, 96, 96.4]
      }

      this.option = {
        color: ['#0C2D82', '#B620E0', '#4634FA', '#F6BB2F', '#50E3C2', '#32C5FF', '#0091FF', '#0394FF', '#F7B500', '#FA6400', '#E02020'],
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3'
            }
          }
        },
        legend: {
          type: 'scroll',
          data: [this.$t('数量'), this.$t('在线率(%)')],
          textStyle: {
            color: '#CEE2FF'
          },
          itemHeight: 10,
          left: 'left',
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: list.xdata || ['DN15', 'DN20', 'DN25', 'DN32', 'DN40', 'DN50'],
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: ['#074671'],
            }
          },
          axisLabel: {
            color: '#D1F3FF',
            fontSize: 10
          }
        },
        yAxis: [{
          type: 'value',
          name: this.$t('数量(个)'),
          nameTextStyle: {
            color: '#D1F3FF',
            align: 'center',
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: ['#074671'],
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#D1F3FF',
            fontSize: 10
          }
        }, {
          type: 'value',
          min: 0,
          max: 100,
          interval: 20,
          name: this.$t('在线率(%)'),
          nameTextStyle: {
            color: '#D1F3FF',
            align: 'center',
          },
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dotted',
              color: ['#074671'],
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            formatter: '{value} %',
            color: '#D1F3FF',
            fontSize: 10
          }
        }],
        series: seriesData
      }
    }
  }
}
</script>

<style lang="less" scoped>
.meter-reading-size-online {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-container {
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
}

@media (max-width: 1200px) {
  .meter-reading-size-online {
    padding: 0;
  }
}
</style>